module.exports = __webpack_public_path__ + "img/error_icon.e98b6ae5.png";